import React, { Dispatch } from "react";
import { H2, PrimaryButton, SecondaryButton, colorsLight } from "@coherehealth/common";
import { styled, useTheme, Container, Dialog, DialogProps } from "@mui/material";
import ClipboardWarningIcon from "../images/ClipboardWarningIcon";
import { LeftNavBar } from "components/common/Navigation/LeftNavBar";
import { QueueViewState } from "@coherehealth/qm-api";
interface Props extends DialogProps {
  open: boolean;
  headingText?: string;
  queueViewState: QueueViewState;
  setNoCaseAvailable?: Dispatch<boolean>;
  retry?: () => void;
}

export const NoCaseModal = ({ open, headingText, queueViewState, setNoCaseAvailable, retry }: Props) => {
  const { spacing } = useTheme();
  return (
    <FullScreenDialog fullScreen open={open}>
      <LeftNavBar drawerWidth={76} queueViewState={queueViewState} />
      <LoadingContainer>
        <ClipboardWarningIcon />
        <div style={{ paddingTop: spacing(5), textAlign: "center" }}>
          <HeroHeading>{headingText || "Could not find a case"}</HeroHeading>
        </div>
        {!!setNoCaseAvailable && !!retry && (
          <div style={{ display: "inline-flex", paddingTop: spacing(5), gap: spacing(3) }}>
            <SecondaryButton onClick={() => setNoCaseAvailable(false)}>Back to dashboard</SecondaryButton>
            <PrimaryButton
              onClick={() => {
                retry();
                setNoCaseAvailable(false);
              }}
            >
              Try again
            </PrimaryButton>
          </div>
        )}
      </LoadingContainer>
    </FullScreenDialog>
  );
};

const LoadingContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
}));

const HeroHeading = styled(H2)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

const FullScreenDialog = styled(Dialog)(({ theme }) => ({
  ".MuiDialog-paperFullScreen": {
    backgroundColor: colorsLight.background.light,
  },
}));
